module.exports = __webpack_public_path__ + "static/media/cli.b92105c5.gif";